import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { SimulationInfo } from '@classes/simulation/simulation-info';
import { UserRole } from '@classes/licence/user-role';
import { User } from '@classes/licence/user';
import { UiService } from '@services/ui.service';
import { LicenceService } from '@services/licence.service';
import { SimulationService } from '@services/simulation.service';

enum SelectedType { role, user }

@Component({
    selector: 'app-share-simulation',
    templateUrl: './share-simulation.component.html',
    styleUrls: ['./share-simulation.component.scss']
})
export class ShareSimulationComponent implements OnInit, OnDestroy {
    private loadingStateSub: Subscription;

    simulation: SimulationInfo;
    roles: UserRole[];
    selectedRoles: UserRole[] = [];
    selectedUsers: User[] = [];

    isLoading: boolean;

    selectedType = SelectedType;

    constructor(
        private uiSrv: UiService,
        private licenceSrv: LicenceService,
        private simuSrv: SimulationService,
        @Inject(MAT_DIALOG_DATA) public data: { simuToShare: SimulationInfo },
        private dialogRef: MatDialogRef<ShareSimulationComponent>
    ) { }

    ngOnInit() {
        this.simulation = this.data.simuToShare;
        this.initSubscriptions();
    }

    onSelectRole(selected: UserRole): void {
        const index: number = this.selectedRoles.findIndex(r => r.code === selected.code);

        if(index === -1) {
            this.selectedRoles.push(selected);
        } else {
            this.selectedRoles.splice(index, 1);
        }
    }

    onSelectUser(selected: User): void {
        const index: number = this.selectedUsers.findIndex(r => r.username === selected.username);

        if(index === -1) {
            this.selectedUsers.push(selected);
        } else {
            this.selectedUsers.splice(index, 1);
        }
    }

    isRoleSelected(selected: UserRole): boolean {
        return this.selectedRoles.some(r => r.code === selected.code);
    }

    isUserSelected(selected: User): boolean {
        return this.selectedUsers.some(r => r.username === selected.username);
    }

    onShareSimu(): void {
        const message = 'main.dialogs.confirmShareSimu.summary';
        const dataToShare = {
            roles: this.selectedRoles,
            users: this.selectedUsers
        };

        this.uiSrv.confirmDialog(message).afterClosed()
        .subscribe((result: boolean) => {
            // if user send "Yes" continue navigation
            if(result) {
                this.simuSrv.share(dataToShare, this.simulation.code)
                .subscribe(() => {
                    // this.bottomSheetRef.dismiss();
                    this.dialogRef.close();
                });
            }
        });
    }

    onCancel(): void {
        // this.bottomSheetRef.dismiss();
        this.dialogRef.close();
    }

    private initSubscriptions(): void {
        this.licenceSrv.getCurrentRoles()
        .subscribe(roles => {
            this.roles = roles;
        });

        this.loadingStateSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    ngOnDestroy() {
        if(this.loadingStateSub) {
            this.loadingStateSub.unsubscribe();
        }
    }
}
